import styled from 'styled-components';
import { Button } from '../../components';
import { ICON_TYPES, IconType } from '../../components/NotificationBox';
import { Disclaimer } from '../../components/Result/Result.styles';
import { NEGATIVE_500 } from '../../styles/colors';
import { IconFont } from '../../styles/font';
import {
  FONT_WEIGHT_NORMAL,
  FONT_WEIGHT_REGULAR,
} from '../../styles/typography';

const MOBILE_BREAKPOINT = '768px';

const MOBILE_VIEW = `
  line-height: 22px;
  ${FONT_WEIGHT_REGULAR}
`;

const ICON_STYLES = `
  ${IconFont}
  font-family: 'rs-iconfont';
  font-size: 18px;
  font-style: normal;
`;

export const Header = styled.div`
  &&& {
    display: flex;
    gap: 8px;
  }
`;

export const HeaderIcon = styled.i<{ color?: string; content?: IconType }>`
  &&& {
    :before {
      color: ${({ color }) => color || NEGATIVE_500};
      content: '${({ content }) => content || ICON_TYPES.WARNING}';
      ${ICON_STYLES}
      line-height: 24px;
      vertical-align: middle;

      @media (max-width: ${MOBILE_BREAKPOINT}) {
        ${MOBILE_VIEW}
      }
    }
  }
`;

export const HeaderTitle = styled.span`
  &&& {
    @media (max-width: ${MOBILE_BREAKPOINT}) {
      margin: 0 !important;
      ${MOBILE_VIEW}
    }
  }
`;

export const Body = styled.div`
  &&& {
    > span {
      line-height: 20px !important;
      font-size: 14px !important;
      ${FONT_WEIGHT_NORMAL}
    }
  }
`;

export const NotifiedTitle = styled.div`
  &&& {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const NotifiedDescription = styled.div`
  &&& {
    line-height: 20px !important;
    font-size: 14px !important;
    ${FONT_WEIGHT_NORMAL}
    margin-top: 8px;
  }
`;

export const GetNotifiedContainer = styled.div`
  &&& {
    border-radius: 8px;
    padding: 20px;
    margin: 16px 0;

    > *:not(:first-child) {
      margin: 10px 0 0 0 !important;
    }
  }
`;

export const ActionButton = styled(Button)`
  &&& {
    line-height: 29px;
    font-size: 13px;
    ${FONT_WEIGHT_NORMAL}
    padding: 0;
  }
`;

export const PrivacyNoticeDisclaimer = styled(Disclaimer)`
  &&& {
    font-size: 10px !important;
    line-height: 16px !important;
    > * {
      font-size: inherit !important;
      line-height: inherit !important;
    }
  }
`;
